define('modules/form_editor/views/preview_textarea',['require','exports','module','./preview_base','../../editor/models/editorstate','ldsh!../templates/input_textarea'],function(require, exports, module){
  "use strict";
  var InputBase = require("./preview_base"),
      EditorState = require("../../editor/models/editorstate");

  module.exports = InputBase.extend({
    template: require("ldsh!../templates/input_textarea"),
    helpers: function() {
      var isRequired = this.options.model.get('isRequired');
      return {
        isAMP: EditorState.getAMPState(),
        isRequired: isRequired
      };
    }
  });
});

